import React, { useEffect, useState } from "react";
import NonAuthLayout from "../../../layout/NonAuthLayout";
import UsersIndex from "../../../components/SideTab/User/Index";
import { useDispatch } from "react-redux";
import { users } from "../../../redux/states/users/thunk";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import RequestedViewerIndex from "../../../components/SideTab/RequestedViewer";
import { getViewerRequestList } from "../../../redux/actions";

const RequestedViewer = () => {
  const dispatch = useDispatch();
  const [q, setQ] = useSearchParams();
  const [totalPage, setTotalPage] = useState(1);

  const filter = {
    search: q.get("search") || "",
    page: q.get("page") || 1,
    limit: q.get("limit") || 10,
    status: q.get("status") || "",
  };

  const setFilter = (args) => {
    const params = {
      ...filter,
      ...args,
    };
    setQ({
      limit: params.limit || 10,
      orderBy: "createdAt",
      order: -1,
      page: params.page || 1,
      search: params.search || "",
      status: params.status,
    });
  };

  const handlePreviousClick = () => {
    if (filter.page > 1) {
      setFilter({ page: q.get("page") - 1 });
    }
  };

  const handleNextClick = () => {
    if (filter.page < totalPage) {
      setFilter({ page: Number(q.get("page")) + 1 });
    }
  };

  const getViewerRequestLists = (search, pageNo, limit, status) => {
    const data = {
      limit: limit,
      orderBy: "createdAt",
      order: -1,
      page: pageNo,
      search: search,
      status: status,
    };
    //
    dispatch(getViewerRequestList(data))
      .then((response) => {
        const totalCount = response?.payload?.totalcount;
        if (totalCount > 10) {
          const totalpage = totalCount / filter.limit;
          setTotalPage(Math.ceil(totalpage));
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  useEffect(() => {
    getViewerRequestLists(
      filter.search,
      filter.page,
      filter.limit,
      filter.status
    );
    //
  }, [filter]);

  useEffect(() => {
    setQ({ search: filter.search, page: filter.page, limit: filter.limit });
  }, []);

  return (
    <>
      <RequestedViewerIndex
        filter={filter}
        totalPage={totalPage}
        setFilter={setFilter}
        handlePreviousClick={handlePreviousClick}
        getUsersList={getViewerRequestList}
        handleNextClick={handleNextClick}
      />
    </>
  );
};

export default RequestedViewer;
